import { defineComponent as _defineComponent } from 'vue';
import { computed, ref, watch } from 'vue';
import { useMonitoringStore } from '@blade-sxp/monitoring-center/store/index';
import VideoBoxSingle from '@blade-sxp/monitoring-center/pages/components/video-box-single.vue';
import BoxSwapping from '@blade-sxp/monitoring-center/pages/components/box-swapping.vue';
import { useBoxSize } from '@blade-sxp/monitoring-center/pages/preview/utils/useBoxSize';
import { useVideoData } from '@blade-sxp/monitoring-center/pages/preview/utils/useVideoData';
import { useAlarmVideoData } from '@blade-sxp/monitoring-center/pages/preview/utils/useAlarmVideoData';
export default /*#__PURE__*/ _defineComponent({
    __name: 'video-box-group',
    setup(__props) {
        /**
         * 视频框组 组件引入注解
         * <VideoBoxGroup />
         */
        const store = useMonitoringStore();
        const container = ref(null);
        const hideAnimation = ref(true);
        const { delVideoData, deviceClickListen, drop, handleSwapping, showSingleBox, toggleVideoHover, deviceDragleave, deviceDragOver, onFullChange, selectedBoxIndex, swappingShown, singleScreen, dragOverIndex, } = useVideoData();
        const { initAlarmDevice, getStyle } = useAlarmVideoData();
        const { getContentStyle } = useBoxSize(container);
        const videoContentStyle = computed(() => getContentStyle());
        const screenChange = computed(() => {
            return { videoContentStyle, singleScreen, selectedBoxIndex };
        });
        watch(screenChange, () => {
            hideAnimation.value = false;
            setTimeout(() => {
                hideAnimation.value = true;
            }, 0);
        }, { deep: true });
        const contentStyle = computed(() => {
            return {
                width: `${videoContentStyle.value.width}px`,
                height: `${videoContentStyle.value.height}px`,
            };
        });
        const boxSingleStyle = computed(() => {
            if (singleScreen.value) {
                return {
                    width: `${videoContentStyle.value.width - 4}px`,
                    height: `${videoContentStyle.value.height - 4}px`,
                };
            }
            else {
                return {
                    width: `${videoContentStyle.value.width / 2 - 6}px`,
                    height: `${videoContentStyle.value.height / 2 - 6}px`,
                };
            }
        });
        const videoDetailArr = computed(() => store.videoDetailArr);
        // 监听设备添加｜更改
        deviceClickListen();
        // 告警联动初始化
        initAlarmDevice();
        // 监听屏幕变化
        onFullChange();
        return { __sfc: true, store, container, hideAnimation, delVideoData, deviceClickListen, drop, handleSwapping, showSingleBox, toggleVideoHover, deviceDragleave, deviceDragOver, onFullChange, selectedBoxIndex, swappingShown, singleScreen, dragOverIndex, initAlarmDevice, getStyle, getContentStyle, videoContentStyle, screenChange, contentStyle, boxSingleStyle, videoDetailArr, VideoBoxSingle, BoxSwapping };
    }
});
